<nb-card class="lista-crud">
  <nb-card-header class="head">
    <div class="titulo-bloco">
      <span class="titulo-principal">Acesso às turmas</span>
      <span class="titulo-contexto">
        Quem tem acesso vê a turma em "Minhas turmas" e pode lançar a frequência dela.
      </span>
    </div>
  </nb-card-header>

  <nb-card-body>
    <div class="smart-toolbar">
      <div class="campo-filtro campo-filtro--wide">
        <app-autocomplete
          rotulo="Turma"
          placeholder="Digite parte do nome ou o ano"
          [opcoes]="opcoesTurma"
          [selecionadoId]="turmaSelecionada"
          (selecionadoIdChange)="onTurmaChange($event)"
          [buscaNoServidor]="true"
          [carregando]="carregandoTurmas"
          (buscar)="carregarTurmas($event)"
          msgSemResultado="Nenhuma turma encontrada"
        ></app-autocomplete>
      </div>

      <div class="campo-filtro campo-filtro--wide">
        <app-autocomplete
          rotulo="Buscar usuário"
          placeholder="Nome, login ou CPF"
          [opcoes]="opcoesUsuario"
          [selecionadoId]="usuarioSelecionadoId"
          (selecionadoIdChange)="onUsuarioChange($event)"
          [buscaNoServidor]="true"
          [carregando]="buscandoUsuarios"
          [desabilitado]="!turmaSelecionada"
          (buscar)="buscarUsuarios($event)"
          msgSemResultado="Nenhum usuário encontrado (ou todos já têm acesso a esta turma)"
        ></app-autocomplete>
      </div>

      <div class="campo-filtro--acoes">
        <button
          nbButton
          status="success"
          size="medium"
          type="button"
          [disabled]="!usuarioSelecionado || salvando"
          [nbSpinner]="salvando"
          (click)="vincular()"
        >
          <nb-icon pack="eva" icon="person-add-outline"></nb-icon>
          <span>Dar acesso</span>
        </button>
      </div>
    </div>

    <p class="vazio erro" *ngIf="erroVinculos">{{ erroVinculos }}</p>

    <app-barra-carregando *ngIf="carregandoVinculos"></app-barra-carregando>
    <div class="smart-table-wrap" *ngIf="turmaSelecionada && !erroVinculos && vinculados.length">
      <table class="smart-table">
        <thead>
          <tr>
            <th appOrdenavel campo="nome" rotuloAcessivel="Nome" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Nome</th>
            <th appOrdenavel campo="login" rotuloAcessivel="Login" [ordenacao]="ordenacao" (ordenar)="ordenarPor($event)">Login</th>
            <th class="col-acoes col-acoes--icones">Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let vinculo of vinculadosExibidos">
            <td data-label="Nome">{{ vinculo.nome }}</td>
            <td data-label="Login">{{ vinculo.login || '—' }}</td>
            <td class="col-acoes col-acoes--icones" data-label="Ações">
              <div class="acao-btns acao-btns--inline" role="group">
                <button
                  type="button"
                  nbButton
                  size="small"
                  appearance="outline"
                  status="danger"
                  class="btn-acao"
                  (click)="desvincular(vinculo)"
                  title="Remover acesso à turma"
                  aria-label="Remover acesso à turma"
                >
                  <nb-icon pack="eva" icon="person-delete-outline"></nb-icon>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <p class="vazio" *ngIf="!turmaSelecionada">Selecione uma turma para ver quem tem acesso.</p>
    <app-lista-vazia
      *ngIf="turmaSelecionada && !carregandoVinculos && !erroVinculos && !vinculados.length"
      icone="unlock-outline"
      mensagem="Nenhum usuário com acesso a esta turma. Use a busca acima para liberar o acesso."
    ></app-lista-vazia>
  </nb-card-body>
</nb-card>
